import React from 'react';

import { SignupByInvitePageForm } from 'src/components/auth';
import { PositionDetailsModal } from 'src/modals/position';
import { AuthSignupProvider } from 'src/providers/AuthSignupProvider';

export const SignupByInvitePage: React.FC = () => {
  return (
    <AuthSignupProvider>
      <SignupByInvitePageForm />

      <PositionDetailsModal />
    </AuthSignupProvider>
  );
};
